<template>
  <div
    class="html_playerTable"
    ref="html_playerTable"
    v-if="datas.objectInfo && datas.objectInfo.length == 1"
  >
    <div class="main">
      <div class="left-box">
        <span
          class="left_title"
          v-if="datas.objectInfo[0] && datas.objectInfo[0].teamScore"
        >
          <span v-text="'总成绩：'"></span>
          <!-- <span v-text="'657.2'"></span> -->
          <NumberScrolling
            :tarVal="datas.objectInfo[0].teamScore"
            :unit="''"
          ></NumberScrolling>
        </span>
        <template v-if="themetype === 'A'">
          <APlayerImg
            v-for="item in datas.objectInfo"
            :key="item.playerInfos[0].playerId"
            :playerImg="item.playerInfos[0].profilePicture"
            :playerNum="item.playerInfos[0].shirtNumber * 1"
            :playerName="item.playerInfos[0].playerName"
            :countryImg="item.teamLogo"
            :countryName="item.teamName"
            :cssDynamicObj="cssDynamicObj"
            :width="'calc(10vw * var(--mixtmt_mixvw))'"
          ></APlayerImg>
        </template>
        <template v-else-if="themetype === 'D'">
          <DPlayerImg
            :playerInfos="datas.objectInfo[0].playerInfos"
            :countryImg="datas.objectInfo[0].teamLogo"
            :countryName="datas.objectInfo[0].teamName"
            :cssDynamicObj="cssDynamicObj"
            :width="'calc(12vw * var(--mixtmt_mixvw))'"
          ></DPlayerImg>
        </template>

        <template v-else-if="themetype === 'T'">
          <DelegationImg
            v-for="item in datas.objectInfo"
            :key="item.teamId"
            :countryImg="item.teamLogo"
            :countryName="item.teamName"
            :cssDynamicObj="cssDynamicObj"
            :width="'calc(10vw * var(--mixtmt_mixvw))'"
          ></DelegationImg>
        </template>
      </div>
      <div class="table_box" :class="themetype">
        <!-- <span class="t_header">
          <span class="customTable_row">
            <span
              class="customTable_row_cell"
              v-for="columnItem in datas.statisticsModels"
              :key="columnItem.statisticalEn"
            >
              <span v-text="columnItem.name"></span>
            </span>
          </span>
        </span> -->
        <span class="t_body">
          <span class="customTable_row">
            <span
              class="customTable_row_cell"
              v-for="columnItem in datas.statisticsModels"
              :key="columnItem.statisticalEn"
              v-text="columnItem.name"
            ></span>
          </span>
          <span
            class="customTable_row"
            v-for="(rowData, rowIndex) in datas.data.dataList"
            :key="rowIndex"
          >
            <span
              class="customTable_row_cell"
              v-for="columnItem in datas.statisticsModels"
              :key="columnItem.statisticalEn"
            >
              <NumberScrolling
                :tarVal="_valFormatHandler(rowData[columnItem.statisticalEn])"
                :unit="columnItem.suffix"
              ></NumberScrolling>
            </span>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// 运动员数据 单人 || 双人 || 团体  + table表格
import APlayerImg from '../components/PlayerImg'
import DPlayerImg from '../components/DPlayerImg'
import DelegationImg from '../components/DelegationImg'
import NumberScrolling from '../components/NumberScrolling'
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
export default {
  name: 'html_playerTable',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    APlayerImg,
    DPlayerImg,
    DelegationImg,
    NumberScrolling,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  data() {
    return {
      // themetype: 'A', //A:单人；D:双人；T:团队
      // sportType: 'uncombat', //combat: 对抗； uncombat:非对抗
    }
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
    this.$nextTick(() => {
      // 设置CSS变量--main-bg-color的值为'#f0f0f0'
      document.body.style.setProperty(
        '--mixtmt_indicatorItemSelect_mixvw',
        this.cssDynamicObj.mixvw
      )
    })
  },
  updated() {
    console.debug(`更新： ${this.datas}`)
  },
  computed: {
    themetype() {
      let themeType = ''
      const len = this.datas.objectInfo[0].playerInfos.length
      if (len === 0) {
        themeType = 'T'
      } else if (len === 1) {
        themeType = 'A'
      } else if (len === 2) {
        themeType = 'D'
      }
      return themeType
    },
    sportType() {
      let sportType = ''
      const len = this.datas.data.dataList[0].showDataList.length
      if (len === 1) {
        sportType = 'uncombat'
      } else if (len === 2) {
        sportType = 'combat'
      }
      return sportType
    },
  },
  methods: {
    _valFormatHandler(val, text, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = '一'
      } else {
        if (text) {
          data = `${text}: ${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_playerTable {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    width: 98%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);

    .left-box {
      margin-right: calc(0.694vw * var(--mixtmt_mixvw));
      .left_title {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        font-weight: bold;
        padding-bottom: calc(0.694vw * var(--mixtmt_mixvw));
        color: var(--mixtmt_greyColor3);
        span {
          font-size: calc(1.11vw * var(--mixtmt_mixvw));
          line-height: calc(2.083vw * var(--mixtmt_mixvw));
        }
      }
    }
    .table_box {
      position: relative;
      height: auto;
      display: table;
      /* display: block; */
      /* table-layout: auto; */
      /* padding-top: 2.083vw; */
      &.A {
        width: calc(100% - 10vw * var(--mixtmt_mixvw));
      }
      &.D {
        width: calc(100% - 12vw * var(--mixtmt_mixvw));
      }
      &.T {
        width: calc(100% - 10vw * var(--mixtmt_mixvw));
      }
      /* .t_header {
        width: 100%;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        .customTable_row {
          display: table-row;
          height: 2.083vw;
          color: var(--mixtmt_greyColor4);
          width: 100%;
          background: linear-gradient(
            180deg,
            var(--mixtmt_theme_defaultGradient_1_1) 0%,
            var(--mixtmt_theme_defaultGradient_1_2) 98%
          );
          color: var(--mixtmt_whiteColor);
          border-bottom: 0;
          .customTable_row_cell {
            font-size: 0.972vw;
            border-bottom: 0;
          }
        }
      } */
      .t_body {
        width: 100%;
        height: auto;
        /* display: table; */
        display: block;
        max-height: calc(15.62vw * var(--mixtmt_mixvw));
        overflow: auto;
      }

      .customTable_row {
        display: table-row;
        height: calc(2.083vw * var(--mixtmt_mixvw));
        color: var(--mixtmt_greyColor4);
        &:first-child {
          position: sticky;
          top: 0;
          right: 3%;
          z-index: 2;
          display: table-row;
          height: calc(2.083vw * var(--mixtmt_mixvw));
          color: var(--mixtmt_greyColor4);
          width: 100%;
          background: linear-gradient(
            180deg,
            var(--mixtmt_theme_defaultGradient_1_1) 0%,
            var(--mixtmt_theme_defaultGradient_1_2) 98%
          );
          color: var(--mixtmt_whiteColor);
          border-bottom: 0;
          .customTable_row_cell {
            font-size: calc(0.972vw * var(--mixtmt_mixvw));
            border-bottom: 0;
          }
        }
      }

      .customTable_row_cell {
        display: table-cell;
        padding: calc(0.486vw * var(--mixtmt_mixvw)) 0;
        font-size: calc(0.833vw * var(--mixtmt_mixvw));
        line-height: calc(1.11vw * var(--mixtmt_mixvw));
        font-weight: bold;
        text-align: center;
        width: 5%;
        border-bottom: 1px solid var(--mixtmt_greyColor7);
        vertical-align: middle;
      }
    }
  }
}
</style>
